import XCircleIcon from '@/shared/assets/x_circle.svg?react';
import { BorderGradient } from '@/shared/components/border-gradient';
import { Gradients } from '@/shared/components/theme/gradient';
import { cn } from '@/shared/utils/cn';

export const FilterChip = ({
  label,
  onClear,
}: {
  label: string;
  onClear: () => void;
}) => (
  <BorderGradient radius="2xs">
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-2xs px-2 py-1 text-2xs text-white',
        Gradients.purpleBlueGradient,
      )}
    >
      <span className="max-w-[160px] truncate">{label}</span>
      <button
        type="button"
        className="grid place-items-center"
        onClick={onClear}
      >
        <XCircleIcon className="size-3" />
      </button>
    </span>
  </BorderGradient>
);
